/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15.6632 14.1053H18M15.6632 14.1053L17.4 17M15.6632 14.1053L13.5 10.5M6 14.1053H8.33684M8.33684 14.1053H13M8.33684 14.1053L12 8M6.6 17L7.2 16M12 8L13.2 6M12 8L10.8 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				fill="currentColor"
			/>
			<path
				d="M15.6632 14.1053H18M15.6632 14.1053L17.4 17M15.6632 14.1053L13.5 10.5M6 14.1053H8.33684M8.33684 14.1053H13M8.33684 14.1053L12 8M6.6 17L7.2 16M12 8L13.2 6M12 8L10.8 6M2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25305 1.84946C5.42957 1.25 6.96971 1.25 10.05 1.25H13.95C17.0303 1.25 18.5704 1.25 19.7469 1.84946C20.7818 2.37677 21.6232 3.21816 22.1505 4.25305C22.75 5.42957 22.75 6.96971 22.75 10.05V13.95C22.75 17.0303 22.75 18.5704 22.1505 19.7469C21.6232 20.7818 20.7818 21.6232 19.7469 22.1505C18.5704 22.75 17.0303 22.75 13.95 22.75H10.05C6.96971 22.75 5.42957 22.75 4.25305 22.1505C3.21816 21.6232 2.37677 20.7818 1.84946 19.7469C1.25 18.5704 1.25 17.0303 1.25 13.95V10.05C1.25 6.96971 1.25 5.42957 1.84946 4.25305C2.37677 3.21816 3.21816 2.37677 4.25305 1.84946ZM13.8431 6.38587C14.0562 6.03069 13.9411 5.56999 13.5859 5.35688C13.2307 5.14377 12.77 5.25894 12.5569 5.61413L12 6.54226L11.4431 5.61413C11.23 5.25894 10.7693 5.14377 10.4141 5.35688C10.0589 5.56999 9.94377 6.03069 10.1569 6.38587L11.1254 8L7.9122 13.3553H6C5.58579 13.3553 5.25 13.691 5.25 14.1053C5.25 14.5195 5.58579 14.8553 6 14.8553H8.33684H13C13.4142 14.8553 13.75 14.5195 13.75 14.1053C13.75 13.691 13.4142 13.3553 13 13.3553H9.66149L12.6431 8.38587L13.8431 6.38587ZM14.1431 10.1141C13.93 9.75894 13.4693 9.64377 13.1141 9.85688C12.7589 10.07 12.6438 10.5307 12.8569 10.8859L15.02 14.4911L16.7569 17.3859C16.97 17.7411 17.4307 17.8562 17.7859 17.6431C18.1411 17.43 18.2562 16.9693 18.0431 16.6141L16.9878 14.8553H18C18.4142 14.8553 18.75 14.5195 18.75 14.1053C18.75 13.691 18.4142 13.3553 18 13.3553H16.0878L14.1431 10.1141ZM7.84312 16.3859C8.05623 16.0307 7.94106 15.57 7.58587 15.3569C7.23069 15.1438 6.76999 15.2589 6.55688 15.6141L5.95688 16.6141C5.74377 16.9693 5.85894 17.43 6.21413 17.6431C6.56931 17.8562 7.03001 17.7411 7.24312 17.3859L7.84312 16.3859Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M15.6632 14.1053H18M15.6632 14.1053L17.4 17M15.6632 14.1053L13.5 10.5M6 14.1053H8.33684M8.33684 14.1053H13M8.33684 14.1053L12 8M6.6 17L7.2 16M12 8L13.2 6M12 8L10.8 6M2 10V9.5V9.5C2 7.17029 2 6.00544 2.3806 5.08658C2.88807 3.86144 3.86144 2.88807 5.08658 2.3806C6.00544 2 7.17029 2 9.5 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H9.5C7.17029 22 6.00544 22 5.08658 21.6194C3.86144 21.1119 2.88807 20.1386 2.3806 18.9134C2 17.9946 2 16.8297 2 14.5V14.5V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15.6632 14.1053H18M15.6632 14.1053L17.4 17M15.6632 14.1053L13.5 10.5M6 14.1053H8.33684M8.33684 14.1053H13M8.33684 14.1053L12 8M6.6 17L7.2 16M12 8L13.2 6M12 8L10.8 6M2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.05 1.25C6.96971 1.25 5.42957 1.25 4.25305 1.84946C3.21816 2.37677 2.37677 3.21816 1.84946 4.25305C1.25 5.42957 1.25 6.96971 1.25 10.05V13.95C1.25 17.0303 1.25 18.5704 1.84946 19.7469C2.37677 20.7818 3.21816 21.6232 4.25305 22.1505C5.42957 22.75 6.96971 22.75 10.05 22.75H13.95C17.0303 22.75 18.5704 22.75 19.7469 22.1505C20.7818 21.6232 21.6232 20.7818 22.1505 19.7469C22.75 18.5704 22.75 17.0303 22.75 13.95V10.05C22.75 6.96971 22.75 5.42957 22.1505 4.25305C21.6232 3.21816 20.7818 2.37677 19.7469 1.84946C18.5704 1.25 17.0303 1.25 13.95 1.25H10.05Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.5859 5.35699C13.9411 5.5701 14.0562 6.0308 13.8431 6.38599L12.6431 8.38599L9.66149 13.3554H13C13.4142 13.3554 13.75 13.6912 13.75 14.1054C13.75 14.5196 13.4142 14.8554 13 14.8554H8.33684H6C5.58579 14.8554 5.25 14.5196 5.25 14.1054C5.25 13.6912 5.58579 13.3554 6 13.3554H7.9122L11.1254 8.00011L10.1569 6.38599C9.94377 6.0308 10.0589 5.5701 10.4141 5.35699C10.7693 5.14388 11.23 5.25906 11.4431 5.61424L12 6.54238L12.5569 5.61424C12.77 5.25906 13.2307 5.14388 13.5859 5.35699ZM13.1141 9.85699C13.4693 9.64388 13.93 9.75906 14.1431 10.1142L16.0878 13.3554H18C18.4142 13.3554 18.75 13.6912 18.75 14.1054C18.75 14.5196 18.4142 14.8554 18 14.8554H16.9878L18.0431 16.6142C18.2562 16.9694 18.1411 17.4301 17.7859 17.6432C17.4307 17.8563 16.97 17.7412 16.7569 17.386L15.02 14.4912L12.8569 10.886C12.6438 10.5308 12.7589 10.0701 13.1141 9.85699ZM7.58587 15.357C7.94106 15.5701 8.05623 16.0308 7.84312 16.386L7.24312 17.386C7.03001 17.7412 6.56931 17.8563 6.21413 17.6432C5.85894 17.4301 5.74377 16.9694 5.95688 16.6142L6.55688 15.6142C6.76999 15.2591 7.23069 15.1439 7.58587 15.357Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
